/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('global/RocAnalytics',[
    'jquery',
    './Logger',
    './GoogleAnalytics'
], function ($, Logger, GoogleAnalytics) {
    // inject GoogleAnalytics service. Can replace with any other analytics serivce.

    function getItemData(element, attr) {
        return $(element).parents('.itemWrapper').attr('data-' + attr);
    }

    // event onclick for attribute data-roc-action
    // this is first option of behavior when we add 
    // our module to all.js and try to use data-attributes
    // such behavior doesn't work if we need pass many fields
    function productClick() {
        $(document).on('click', '.itemWrapper[data-product-id] a.itemLink', function (e) {
            var itemData = $(this).closest('.itemWrapper').data('rocParams');

            if (itemData.name) {
                var data = {
                    'id': itemData.sku || itemData.externalid || itemData.id,
                    'name': itemData.name,
                    'list': itemData.list,
                    'position': itemData.position
                };

                recordProductClick(data);
            }
        });
    };

    // checking if page consist attribute data-product-id. If yes, then send impression to GA
    function productImpression() {
        $(document).ready(function () {
            var selector = document.querySelectorAll('.itemWrapper[data-product-id]');
            if (typeof selector !== typeof undefined && selector !== false) {
                $(selector).each(function () {
                    var item = $(this);
                    var itemData = $(this).data('rocParams');

                    if (itemData.name) {
                        var data = {
                            'id': itemData.sku || itemData.externalid || itemData.id,
                            'name': itemData.name,
                            'list': itemData.list,
                            'position': itemData.position
                        };

                        recordProductImpression(data);

                        item.data('rocParams').isViewed = true;
                    }
                });
            }
        });
    }

    productClick();
    productImpression();

    function recordProductClick(data) {
        GoogleAnalytics.setProductClick(data);
    }

    function recordProductImpression(data) {
        GoogleAnalytics.setImpression(data);
    }

    function recordProductImpressionDetailed(data, isInteraction) {
        GoogleAnalytics.setImpressionDetailed({
            id: data.sku || data.externalid || data.id,
            name: data.name
        }, isInteraction);
    }

    function recordAddProductToCart(data) {
        GoogleAnalytics.addToCart({
            id: data.sku || data.externalid || data.id,
            name: data.name,
            variant: data.variant,
            price: data.price,
            quantity: data.qty
        });
    }

    function recordRemoveProductFromCart(data) {
        GoogleAnalytics.removeFromCart({
            id: data.sku || data.externalid || data.id,
            name: data.name,
            variant: data.variant,
            price: data.price,
            quantity: data.qty
        });
    }

    function recordCheckoutStep(products, step, isUserInteraction, optionalData) {
        GoogleAnalytics.Checkout.setCheckoutStep(products, step, isUserInteraction, optionalData);
    }

    function recordCheckoutOption(step, optionalData, callback) {
        GoogleAnalytics.Checkout.setCheckoutOption(step, optionalData, callback);
    }

    function recordSetPurchase(products, purchase, isSend) {
        if (isSend) {
            return;
        }
        GoogleAnalytics.setPurchase(products, purchase);
    }

    var RocAnalytics = {
        productImpression: productImpression,
        recordProductClick: recordProductClick,
        recordProductImpression: recordProductImpression,
        recordProductImpressionDetailed: recordProductImpressionDetailed,
        recordSetPurchase: recordSetPurchase,
        recordAddProductToCart: recordAddProductToCart,
        recordRemoveProductFromCart: recordRemoveProductFromCart,
        recordCheckoutStep: recordCheckoutStep,
        recordCheckoutOption: recordCheckoutOption
    }

    return RocAnalytics;
});
